import { BUILD_VERSION } from './version';

export const environment = {
  buildVersion: BUILD_VERSION,
  apiBasePath: 'https://bookingapi.wellext.de/api/v1',
  paypalClientId: 'AVEHapRkk7VM0ELc8D7SrC7tYu13r9tHGR_3jxcji7OcKonZNCKzZkyTplk9FXZeNS9QyvXlATW-r5SV',
  stripePublishableKey:
    'pk_live_51UC6b0EiE0fttAo32J2Xp7x7n688VzMmmUsNjsgNyF6L2YVhdp0eHpOE2vHho2C0X9rDZQtRdnhd3lNavXyqPpSk00E3bOz6Qw'
};
